// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"bb8815cf","87":"cfe7ee2b","350":"c53b682a","416":"69ede828","474":"95808fff","640":"133145c6","983":"f6d027e1"}[chunkId] + ".css";
};